import { Box, Card, CardContent, Typography } from '@mui/material';

export default function RestaurantMetricCards({ items, label = 'Report summary' }) {
    return <Box role="group" aria-label={label} sx={{ display: 'grid', gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', lg: `repeat(${Math.min(items.length, 4)}, minmax(0, 1fr))` }, gap: 1.5 }}>
        {items.map(item => <Card key={item.label} variant="outlined" sx={{ minWidth: 0, borderTop: '3px solid', borderTopColor: 'primary.main' }}><CardContent>
            <Typography variant="body2" color="text.secondary">{item.label}</Typography>
            <Typography component="p" sx={{ fontWeight: 800, fontSize: '1.5rem', lineHeight: 1.3, mt: 0.75, fontVariantNumeric: 'tabular-nums', overflowWrap: 'anywhere' }}>{item.value}</Typography>
            {item.detail && <Typography variant="caption" color="text.secondary">{item.detail}</Typography>}
        </CardContent></Card>)}
    </Box>;
}
